const ORIENTATION_PORTRAIT = 1;
const ORIENTATION_LANDSCAPE = 2;

export const isIOSChromeBrowser = () => navigator.userAgent.includes('CriOS');

export const getDeviceOrientation = () => {
  let isLandscape = false;
  if (window.orientation) {
    isLandscape = Math.abs(window.orientation) === 90;
  } else if (window.screen.orientation) {
    isLandscape = window.screen.orientation.type.split('-')[0] === 'landscape';
  }

  return isLandscape ? ORIENTATION_LANDSCAPE : ORIENTATION_PORTRAIT;
};

export const isPortraitOrientation = orientation => orientation === ORIENTATION_PORTRAIT;
export const isLandscapeOrientation = orientation => orientation === ORIENTATION_LANDSCAPE;

let timerId = null;
let currentOrientation = getDeviceOrientation();
const listeners = [];

const runOrientationListening = () => {
  let orientation = getDeviceOrientation();

  if (orientation !== currentOrientation) {
    listeners.forEach(listener => listener(orientation));
    currentOrientation = orientation;
  }

  timerId = setTimeout(() => requestAnimationFrame(runOrientationListening), 100);
};

const stopOrientationListening = () => {
  clearTimeout(timerId);
  timerId = null;
};

export const registerOrientationListener = listener => {
  listeners.push(listener);

  if (!timerId) {
    runOrientationListening();
  }

  return () => {
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);

    if (listeners.length === 0) {
      stopOrientationListening();
    }
  };
};
